import { Accessor, DefaultProps } from '@deck.gl/core';
import { LineLayer, LineLayerProps } from '@deck.gl/layers';
import isHiddable from '../modules/isHiddableModule';

export class HidableLineLayer<TData, TExtraProps = object> extends LineLayer<TData, TExtraProps & { getIsHidden: Accessor<TData, 0 | 1> }> {
    static defaultProps: DefaultProps<LineLayerProps<unknown> & { getIsHidden: Accessor<unknown, 0 | 1> }> = {
        getIsHidden: { type: 'accessor', value: 0 }
    };

    static layerName = 'HidableLineLayer';
    initializeState() {
        super.initializeState();
        this.getAttributeManager()!.addInstanced({
            isHidden: {
                size: 1,
                accessor: 'getIsHidden',
                defaultValue: 0.0
            }
        });
    }

    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, isHiddable]
        };
    }
}
